import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, CATEGORY_LABELS, CATEGORY_STYLES, COLOR_STYLES } from "@/lib/api";

const CategoriesContext = createContext(null);
const FALLBACK_STYLE = "bg-gray-100 text-gray-700 border-gray-200";

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState([]);

  const load = useCallback(() => {
    api.get("/categories")
      .then((r) => setCategories(r.data.categories || []))
      .catch((e) => console.debug("categories load failed", e));
  }, []);

  useEffect(() => { load(); }, [load]);

  const byKey = Object.fromEntries(categories.map((c) => [c.key, c]));

  const catLabel = useCallback((key) => {
    if (!key) return "";
    return byKey[key]?.label || CATEGORY_LABELS[key] || key;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories]);

  const catStyle = useCallback((key) => {
    const c = byKey[key];
    if (c) return COLOR_STYLES[c.color] || FALLBACK_STYLE;
    return CATEGORY_STYLES[key] || FALLBACK_STYLE;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories]);

  return (
    <CategoriesContext.Provider value={{ categories, catLabel, catStyle, reload: load }}>
      {children}
    </CategoriesContext.Provider>
  );
}

export function useCategories() {
  const ctx = useContext(CategoriesContext);
  if (!ctx) {
    return {
      categories: [],
      catLabel: (k) => CATEGORY_LABELS[k] || k,
      catStyle: (k) => CATEGORY_STYLES[k] || FALLBACK_STYLE,
      reload: () => {},
    };
  }
  return ctx;
}
